export default __webpack_public_path__ + "static/media/banner-design.b81b366c.png";